<script setup>
import {Link} from '@inertiajs/vue3';
import {generate} from "geopattern";

defineProps({
    collection: Object,
    link: Boolean,
    prefix: String | null,
});
</script>

<template>
    <div class="relative mb-6 group" v-if="collection">
        <div aria-hidden="true" class="absolute inset-0 overflow-hidden border border-transparent rounded-md">
            <img :src="collection.backgroundImage ?? generate(collection.name).toDataUri()"
                 alt="" class="h-full w-full object-cover object-center scale-110" :class="(collection.backgroundImage ? 'blur-md' : ' ') + (link ? ' group-hover:scale-100 transition transition-duration-300' : '')"/>
        </div>
        <div aria-hidden="true" class="absolute inset-0 bg-gray-900 opacity-30 border border-transparent rounded-md"/>
        <div class="relative mx-auto flex max-w-5xl items-center px-6 py-12 lg:px-8">
            <div v-if="collection.imageSrc" class="hidden lg:flex flex-shrink-0 w-36 justify-start">
                <img :src="collection.imageSrc" :alt="collection.name"
                     class="h-36 w-36 rounded-full object-cover shadow-lg"/>
            </div>
            <div class="flex-1 flex flex-col items-center text-center">
                <h2 class="text-xl font-bold tracking-tight text-gray-300 lg:text-2xl" v-if="prefix">{{ prefix }}</h2>
                <h1 class="text-4xl font-bold tracking-tight text-white lg:text-6xl drop-shadow-lg">{{ collection.name }}</h1>
                <p class="mt-4 text-xl text-white whitespace-pre-line" v-if="collection.description">{{ collection.description }}</p>
                <div class="mt-8 text-sm" v-if="link && collection.browseUrl">
                    <Link :href="collection.browseUrl"
                          class="whitespace-nowrap rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        Browse All
                        <span aria-hidden="true"> &rarr;</span>
                    </Link>
                </div>
                <slot />
            </div>
            <div v-if="collection.imageSrc" class="hidden lg:block flex-shrink-0 w-36"/>
        </div>
    </div>
</template>
